import React, { useCallback } from 'react';
import { applicationStore } from '@pascal/pascal-core/shared/core/store';
import { observer } from 'mobx-react-lite';
import { useTranslation } from '@pascal/pascal-core';
import LogoImg from '../../assets/images/turbo-poker/logo.png';
import { gameStore } from '../../store/gameStore';

export const WebLogo = observer(() => {
  const { isDemo } = applicationStore;
  const { resetGameState } = gameStore;
  const t = useTranslation();

  const handleDemoSwitcher = useCallback(() => {
    applicationStore.demoSwitcher(resetGameState);
  }, [resetGameState]);

  return (
    <div className='turbo-poker-web-top-inner'>
      <div className='turbo-poker-web-top-holder'>
        <div className='logo-img-wrp'>
          <img src={LogoImg} alt='logo' />
        </div>
        <div className='play-for-real-btn-wrp'>
          {isDemo && (
            <button onClick={handleDemoSwitcher} className='play-for-real-btn'>
              {t('PLAY_FOR_REAL')}
            </button>
          )}
        </div>
      </div>
    </div>
  );
});
